export const environment = {
  envName: 'prod',
  phoenixTrpc: '/trpc',
  gtagId: ['G-8H86HCEVQL'],
  firebase: {
    apiKey: 'AIzaSyCpTk8_Cy5nULeLczfjHIBWd6B8Z3wLkBQ',
    authDomain: 'stable-glass-183220.firebaseapp.com',
    projectId: 'stable-glass-183220',
    storageBucket: 'stable-glass-183220.appspot.com',
    messagingSenderId: '213003555449',
    appId: '1:213003555449:web:55c08debfabc65e0f4faa8',
  },
  authProviders: {
    q6: {
      name: 'Q6',
      provider: 'google.com',
      providerName: 'Q6Cyber',
      fullLabel: 'Sign in with',
      icon: '/assets/images/google_logo.png',
    },
    password: {
      name: 'UserPass',
      providerName: 'Q6Cyber',
      provider: 'password',
      fullLabel: 'Sign in with',
      icon: '',
    },
    test: {
      name: 'Test',
      provider: 'oidc.oauth-dev-test',
      providerName: 'OAuth Dev Test',
      fullLabel: 'Sign in with',
      icon: '',
    },
  },
  airbrake: {
    projectId: 531910,
    projectKey: '30dab1a0108fd5f44bc0374e971e4eb9',
  },
  growthBook: {
    apiHost: 'https://featureflags-proxy.q6cyber.com',
    clientKey: 'sdk-gPvUQW1xsgWWXQLF',
  },
};
